import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { HamburgerLabel, LinkHamburgerMenu, HamburgerMenuIcon } from './HamburgerMenu.style';
import { useCommon } from 'src/domains/common/Common';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

export const HamburgerMenu = observer('HamburgerMenu', () => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    return (
        <LinkHamburgerMenu
            dataTest='mobile-hamburger-menu'
            onClick={appLayoutsState.overlay.toggleMenu}
        >
            <HamburgerMenuIcon />
            <HamburgerLabel>
                <I18n
                    langKey='common.hamburger-menu.label'
                    defaultText='Hamburger Menu'
                />
            </HamburgerLabel>
        </LinkHamburgerMenu>
    );
});
